module.exports = __webpack_public_path__ + "img/m-hd.1dbec5d1.webp";